import HelpCenterRoutes, { HELPCENTER_BASE_ROUTE } from './HelpCenterRoutes';

export { HelpCenterRoutes, HELPCENTER_BASE_ROUTE };
